<template>
  <div class="player-layout">
    <div class="player">
      <div id='video-player'></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentVid: ''
  },
  data () {
    return {
      id: 'v_' + Math.random(),
      player: null
    }
  },
  mounted () {
    var vid = this.currentVid
    this.player = new window.DingLingMobilePlayer({
      src: 'klk',
      loop: false,
      autoplay: true,
      wrapper: 'video-player' // 必填 播放器容器id或容器元素
      // muted: (window.navigator.userAgent.indexOf("Firefox") != -1)?true: false
    })
    this.player.addListener('PlayStop', () => {
      this.$emit('onEnd')
    })
    this.player.fetchVideoInfo(vid)
    setTimeout(() => {
      this.player.playVideo()
    }, 500)
  },
  updated () {
    if (this.player) {
      this.player.stopVideo()
    }
    this.player.fetchVideoInfo(this.currentVid)
  }
}
</script>

<style scoped>
  .player-layout {
    background-color: #000;
    position: relative;
    overflow: hidden;
    display: block;
    width: 100%;
    padding-bottom: 56.25%;
  }
  .player {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  #video-player{
    width: 100%;
    height: 100%;
  }
  #video-player :deep(.cetbox .t1) {
    display: none;
  }
  #video-player :deep(.cetbox .btn-link) {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/player.vue